import React from 'react';
import { Text } from '@Sage/hoi-poi-ui';

const AddressCell = (params) => {
    const { data } = params;
    return (
        <div className="sender-address-cell">
            <Text type="body">{data.address}</Text>
            {(data.city || data.countryName) && (
                <Text type="caption">
                    {data.city && data.countryName
                        ? `${data.city}, ${data.countryName}`
                        : data.city || data.countryName}
                </Text>
            )}
        </div>
    );
};

export default AddressCell;
